import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastNotificationService } from 'src/app/shared/toast-notification/toast-notification.service';
import { StorageKey } from 'src/app/_models/local-storage-key';
import { KnowledgeBaseService } from '../../services/knowledge-base.service';
import { NgIf, NgFor } from '@angular/common';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { LollySpinnerLoaderComponent } from 'components';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatCard } from '@angular/material/card';

@Component({
	standalone: true,
	selector: 'app-knowledge-base',
	templateUrl: './knowledge-base.component.html',
	styleUrls: ['./knowledge-base.component.scss'],
	imports: [
		NgIf,
		MatMenuTrigger,
		MatMenu,
		MatMenuItem,
		LollySpinnerLoaderComponent,
		MatFormField,
		MatLabel,
		MatInput,
		FormsModule,
		NgFor,
		MatCard
	]
})
export class KnowledgeBaseComponent implements OnInit {
	public name: string = '';
	public page: number = 1;
	public topic: string = '';
	public des: string = '';
	public email: string = '';
	public loading: boolean = false;
	public ticketsLoading: boolean = false;
	public submitTicketLoading: boolean = false;
	public categories = [];
	public categoryLinks = [];
	public tickets = [];
	selectedCategory = '';
	public selectedTicket: any;
	public isMobileView: boolean = false;
	public hideBack: boolean = false;
	public statusMap = {
		open: 'Open',
		on_hold: 'On Hold',
		escalated: 'Escalated',
		closed: 'Closed'
	};

	constructor(
		public dialogRef: MatDialogRef<KnowledgeBaseComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private knowledgeBaseService: KnowledgeBaseService,
		private toast: ToastNotificationService
	) {}

	ngOnInit(): void {
		this.hideBack = !!this.data?.hideBack;

		if (screen.width < 480) {
			this.isMobileView = true;
		} else this.isMobileView = false;

		let token = JSON.parse(localStorage.getItem(StorageKey.decodedJwtIo));
		this.name = token.user_firstname;
		this.email = token.username;

		// this.getAllCategories();
		this.getAllSubCategories();
	}

	public getAllCategories(): void {
		this.loading = true;
		this.knowledgeBaseService
			.getAllCategories()
			.then(res => {
				this.loading = false;
				// this.categories = res.filter((i: any) => i.name == 'Lolly' || i.name == 'Brands');
				this.categories = res.filter((i: any) => i.name == 'Brands');
			})
			.catch(err => {
				this.onCatch(err);
			});
	}

	public getAllSubCategories(): void {
		this.loading = true;
		this.knowledgeBaseService.getAllBrandCategory().then(
			res => {
				this.loading = false;
				this.categoryLinks = res;
			},
			err => this.onCatch(err)
		);
	}

	public onNoClick(): void {
		this.dialogRef.close();
	}

	public getStatusClass(status: string): string {
		status = status.toLowerCase();

		return this.statusMap[status];
	}

	public openCardPage(id: string, name: string = ''): void {
		this.page = 2;
		this.loading = true;
		this.selectedCategory = name;
		this.knowledgeBaseService.getAllCategoryById(id).then(
			res => {
				this.loading = false;
				this.categoryLinks = res;
			},
			err => this.onCatch(err)
		);
	}

	private resetForm(): void {
		this.topic = '';
		this.des = '';
	}

	public goToSection(page): void {
		this.page = page;
	}

	public submitTicket(): void {
		this.submitTicketLoading = true;
		this.knowledgeBaseService
			.submitTicket(this.topic, this.des)
			.then(res => {
				this.submitTicketLoading = false;
				this.resetForm();
				this.openViewTicket();
				this.toast.sendSuccessToast(
					'Request Submitted. Your ticket details have also been emailed to you'
				);
			})
			.catch(err => {
				this.submitTicketLoading = false;
				this.toast.sendErrorToast(
					'Something went wrong, Please try again later'
				);
			});
	}

	public onCatch(err): void {
		this.loading = false;
		this.toast.sendErrorToast(
			'Something went wrong, Please try again later'
		);
	}

	public openViewTicket(): void {
		this.page = 4;
		this.ticketsLoading = true;
		this.tickets = [];
		this.knowledgeBaseService
			.getAllTickets()
			.then(res => {
				this.ticketsLoading = false;
				this.tickets = res;
			})
			.catch(_ => {
				this.ticketsLoading = false;
				this.toast.sendErrorToast(
					'Something went wrong, Please try again later'
				);
			});
	}

	public openTicketCreation(): void {
		this.page = 3;
	}

	public viewTicketDetails(index: number): void {
		this.page = 5;
		this.loading = true;
		const ticket = this.tickets[index];

		this.knowledgeBaseService
			.getTicket(ticket.ticket_id)
			.then(res => {
				// console.log(res);
				this.loading = false;
				this.selectedTicket = res[0];

				if (!this.selectedTicket) throw 'no data';
			})
			.catch(err => {
				this.goBack();
				this.onCatch(err);
			});
	}

	public goBack(): void {
		if (this.page === 3) {
			this.openViewTicket();
		} else this.page = 4;
	}

	public goTo(link: string): void {
		window.open(link, '_blank');
	}
}
